module.exports = __webpack_public_path__ + "img/gear-D-high_108x108.b6ddd7c9.png";